import ShareableLinkDialog from './ShareableLinkDialog'

export default ShareableLinkDialog
